import { render, staticRenderFns } from "./VendorManagementForms.vue?vue&type=template&id=408403c7"
import script from "./VendorManagementForms.vue?vue&type=script&lang=js"
export * from "./VendorManagementForms.vue?vue&type=script&lang=js"
import style0 from "./VendorManagementForms.vue?vue&type=style&index=0&id=408403c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports